export default {
  "foot": {
    "title": "Century Games 玩家",
    "p1": "输入账号后，您可选择商品购买。若未入帐可尝试重启游戏，或联系游戏客服。",
    "p2": "若有疑问，请联系游戏客服，感谢您的支持！",
    "copyright": "© Copyright 2024 Century Games.",
    "service": "服务协议",
    "policy": "隐私政策",
    "descriptionTitle": "充值说明"
  },
  "accept": {
    "title": "我们使用必要的cookies 以提供服务并改善您的体验，更多资讯，请参阅我们的<a href=\"https://www.centurygames.com/zh/privacy-policy/\" style=\"color: #58a8a5 ; \">隐私政策</a>。",
    "decline": "拒绝",
    "accept": "接受"
  },
  "game": {
    "inapptext": "通过游戏登录",
    "loginfail": "登录失败",
    "logintip": "若授权失败，请将游戏应用程序更新到最新版本，或尝试使用其他浏览器访问网站。",
    "reloadmsg": "请点击「重新加载」以取得登录结果",
    "reload": "重新加载",
    "appnotice": "若您想要通过游戏授权登录，请使用外部浏览器访问网站。",
    "changeaccount": "确定要退出登录吗？",
    "login": "登录",
    "notice": "提醒",
    "confirm": "确认",
    "loginuserid": "账号",
    "palceholder": "输入账号",
    "okbtn": "确认",
    "loginbtn": "游戏授权",
    "changebtn": "游戏账号登录",
    "useTitle": "帐号",
    "checkBtn": "确认",
    "findid": "找不到您的账号？",
    "checktext": "账号通常显示在设定中，可点击问号标志以取得更多资讯。",
    "username": "昵称：",
    "userId": "账号：",
    "packageTitle": "选择商品",
    "edit": "修改",
    "paymentTitle": "付款方式",
    "total": "总价",
    "goPay": "付款",
    "noSelectPackageTips": "请先选择商品",
    "payFail": "付款失败",
    "camelPayfail": "付款失败",
    "payFailTips1": "若需协助，请联系 Adyen 客服",
    "payFailTips2": "若需协助，请联系 PayPal 客服",
    "paySuccess": "付款成功",
    "paySuccessTips2": "若商品未入帐，请重新启动游戏或联系客服！",
    "camelPaySuccess": "付款成功",
    "transactionId": "订单 ID",
    "paySuccessTips": "商品发货可能有延迟，请稍候",
    "deliveryFail": "商品发货失败",
    "deliveryFailTips": "若需协助，请联系游戏客服",
    "orderTitle": "订单资讯",
    "paidWith": "付款方式",
    "orderID": "订单 ID",
    "payStatus": "付款状态",
    "orderTotal": "总价",
    "transactionDate": "订单时间",
    "goOnPay": "再买一笔",
    "getInvoice": "收据",
    "camelDeliveryFail": "商品发货失败",
    "confirmOrder": "确认订单",
    "confirmFollow": "请确认下列资讯：",
    "nickname": "昵称",
    "packageName": "商品",
    "totalPayment": "总价",
    "confirmPayWith": "付款方式",
    "confirmAndGoOn": "确认并付款",
    "orderCancel": "取消",
    "getInvoiceTitle": "通过邮件发送",
    "getInvoiceTips": "请提供邮箱以取得收据",
    "getInvoiceTips1": "请填写邮箱",
    "getInvoiceTips2": "同意记录您的信箱",
    "getInvoiceTips3": "同意收到折扣、促销、游戏活动等邮件",
    "invoiceSend": "发送",
    "sendSuccess": "发送成功",
    "id404": "账号不存在",
    "packageLoadingText": "商品更新中",
    "taxTips": "价格含税",
    "adyenTips": "付款服务由 Adyen 提供，该公司持有银行执照，并由荷兰中央银行监管。若对其认证有任何疑问，请阅读<a href=\"https://www.adyen.com/platform/certifications\">https://www.adyen.com/platform/certifications</a>，若需了解其使用者资料保护政策，请阅读<a href=\"https://www.adyen.com/policies-and-disclaimer/privacy-policy\">https://www.adyen.com/policies-and- disclaimer /privacy-policy</a>。",
    "paypalTips": "付款服务由 PayPal 提供。若欲了解其使用者资料保护政策，请阅读<a href=\"https://www.paypal.com/c2/webapps/mpp/ua/privacy-full\">https://www.paypal.com/ c2 /webapps/mpp/ua/privacy-full</a>。",
    "switchCountryTips": "您常用的国家/地区为 ${servercountry}，是否切换国家及币种?",
    "paypalBtn": "刷卡付款",
    "paypalOr": "或",
    "paypalCard1": "持卡人姓名（选填）",
    "paypalCard2": "卡号",
    "checkUserID": "绑定",
    "success": "成功",
    "changeCurrencyContent": "确定要切换区域和货币以符合您游戏内的设定：${servercountry}吗？",
    "productDescription": "农富币是以现金付款后取得的货币，用于购买游戏中的礼包和优惠产品。",
    "payButton": "付款",
    "userIdNotice": "请先输入您的账号以绑定",
    "account": "帐号",
    "card": "银行卡",
    "notification": "输入您的账号以绑定，选择欲购买的商品后用首选支付方式付款。重新启动游戏后，购买的商品即会存入帐号中供使用。\n\n若您有任何疑问，欢迎随时在游戏内使用客服系统与我们联系。",
    "rongluRank": "大熔炉等级：",
    "tips": "如何使用？",
    "checkTIps1": "我已阅读并同意<a :href=\"policyUrl\">《隐私政策》</a>、<a :href=\"serviceURl\">《服务协议》</a>及<a :href=\"paymentURl\">《支付条款》</a>。",
    "checkTIps2": "请阅读并勾选协议",
    "selectTips": "（系统会自动选择您最近在游戏中充值所使用的币种)",
    "koPayTips": "若您的银行卡使用了境外韩币结账服务（DCC），会产生额外的手续费，这个费用是由第三方代理收取，而非本网站收取。",
    "PayTips": ""
  },
  "invoice": {
    "title": "付款收据",
    "transactionId": "订单 ID",
    "transactionDate": "订单时间",
    "totalAmount": "总价",
    "paymentMethod": "付款方式",
    "description": "描述",
    "game": "游戏",
    "quantity": "商品数量",
    "price": "价格",
    "amount": "总价",
    "total": "总价",
    "footTitle": "备注",
    "footContent": "感谢您对 Century Games 的支持！",
    "button1": "获取收据",
    "button2": "无需收据直接返回",
    "giveupInvoice": "您将无法收到该订单的收据。确认不需要收据吗？"
  },
  "payment": {
    "card": "信用卡/借记卡",
    "paypal": "PayPal"
  },
  "country": {
    "countryTitle1": "国家/地区",
    "Africa": "非洲",
    "America": "美洲",
    "Asia": "亚洲",
    "Europe": "欧洲",
    "Oceania": "大洋洲",
    "ZA": "南非",
    "US": "美国",
    "HK": "中国香港",
    "JP": "日本",
    "KR": "韩国",
    "SG": "新加坡",
    "SA": "沙特阿拉伯",
    "IQ": "伊拉克",
    "TW": "中国台湾",
    "TH": "泰国",
    "GB": "英国",
    "AU": "澳洲",
    "countryLanguage1": "语言",
    "AE": "阿拉伯联合酋长国",
    "DE": "德国",
    "PT": "葡萄牙",
    "RU": "俄罗斯",
    "ES": "西班牙",
    "CH": "瑞士",
    "TR": "土耳其",
    "KW": "科威特",
    "QA": "卡塔尔",
    "PL": "波兰",
    "ID": "印度尼西亚",
    "IT": "意大利",
    "IN": "印度",
    "FR": "法国",
    "CA": "加拿大",
    "NL": "荷兰",
    "AT": "奥地利",
    "RS": "塞尔维亚",
    "SE": "瑞典",
    "MY": "马来西亚",
    "BE": "比利时",
    "DK": "丹麦",
    "FI": "芬兰",
    "PH": "菲律宾",
    "NO": "挪威",
    "BR": "巴西",
    "NZ": "新西兰",
    "UA": "乌克兰",
    "RO": "罗马尼亚"
  },
  "extra_info": {
    "kingdom": "所在王国："
  },
  "adyen": {
    "note": "本支付服务由 Adyen 提供。该服务已通过 PCI-DSS 国际信用卡组织最高等级认证，为您提供安全的国内外银行卡支付服务。",
    "note2": "注：勾选“保存以便下次支付使用”。个人信用卡信息仅在当前浏览器保存。"
  },
  "pay": {
    "error1": "如果目前付款发生问题，请稍后重试或更换付款方式。若有疑问，请联络客服。"
  },
  "meta": {
    "title": "《菲菲大冒險》商店",
    "description": "《菲菲大冒險》商店是《菲菲大冒險》官方開設的商店，旨在提供您優惠的儲值方式和遊戲內禮包販售。",
    "keywords": "農場、莊園、種植、市場、升等、升級、探索、地圖、角色、等級、模擬、策略、支付、商店、儲值、付款"
  }
};


// WEBPACK FOOTER //
// ./src/lang/zh-Hans.js